<div id="navbar-1" data-collapse="medium" data-animation="over-right" data-duration="400" data-easing="ease"
    data-easing2="ease" role="banner" class="navbar w-nav">
    <div class="container w-container">
        <a *ngIf="sitio=='EasyMed'" href="/sitio-publico/inicio#QueEsEasyMed" aria-current="page" class="w-nav-brand w--current" style="padding: 0px;">
            <img [src]="srcLogo" alt="" class="image" [ngStyle]="asignaEstiloLogo()">
        </a>
        <a *ngIf="sitio=='Efisys'" href="/sitio-publico/inicio#QueEsEfisys" aria-current="page" class="w-nav-brand w--current" style="padding: 0px;">
            <img [src]="srcLogo" alt="" class="image" [ngStyle]="asignaEstiloLogo()">
        </a>
        <nav *ngIf="sitio=='EasyMed'" id="miMenu" role="navigation" class="nav-menu w-nav-menu">
            <a href="/sitio-publico/inicio#QueEsEasyMed" class="nav-link w-nav-link">Qué es?</a>
            <a href="/sitio-publico/inicio#EasyMedEsSeguro" class="nav-link w-nav-link">Es seguro?</a>
            <a href="/sitio-publico/inicio#UtilizarEasyMed" class="nav-link w-nav-link">Cómo lo obtengo?</a>
            <a routerLink="/sitio-publico/ingreso" aria-current="page" class="nav-button w-nav-link"
                routerLinkActive="w--current" (click)="cerrarMenu($event)">Ingresar</a>
            <!--
                 <a href="courieringreso.html" class="nav-button w-nav-link">Ingreso</a>
            -->
        </nav>
        <nav *ngIf="sitio=='Efisys'" id="miMenu" role="navigation" class="nav-menu w-nav-menu">
            <a href="/sitio-publico/inicio#QueEsEfisys" class="nav-link w-nav-link">Qué es?</a>
            <a href="/sitio-publico/inicio#EfisysEsSeguro" class="nav-link w-nav-link">Es seguro?</a>
            <a href="/sitio-publico/inicio#UtilizarEfisys" class="nav-link w-nav-link">Cómo lo obtengo?</a>
            <a routerLink="/sitio-publico/ingreso" aria-current="page" class="nav-button w-nav-link"
                routerLinkActive="w--current" (click)="cerrarMenu($event)">Ingresar</a>
            <!--
                 <a href="courieringreso.html" class="nav-button w-nav-link">Ingreso</a>
            -->
        </nav>
        <div class="w-nav-button" (click)="clickBoton($event)">
            <div class="burgerline"></div>
            <div class="burgerline"></div>
            <div class="burgerline"></div>
            <!--  <div class="w-icon-nav-menu" (click)="clickBoton($event)"></div>
            -->
        </div>
    </div>
</div>